<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import RegularLineForm from "@/domains/lines/views/regularLines/partials/RegularLineForm.vue"
  import RegularLineService from "@/domains/lines/services/RegularLineService"
  import Modal from "@/core/components/NewModal.vue"
  import Icon from "@/core/components/Icon"
  import SearchSelect from "@/core/components/SearchSelect"

  export default {
    components: {
      Breadcrumbs,
      RegularLineForm,
      Modal,
      Icon,
      SearchSelect,
    },
    data() {
      return {
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          { name: "Gestão de Linhas", path: "lines.regular.index" },
          { name: "Nova Linha Regular", path: "lines.regular.create" },
        ],
        regularLineService: new RegularLineService(),

        lineModel: {
          idlinha: "",
          deitinerario: "",
          destiny_point: null,
          origin_point: null,
          deter_registry: null,
          transportadoraForm: {
            id: null,
            name: "",
          },
          dtalteracaolinha: "",
          dtfimcontrato: "",
          dtiniciocontrato: "",
          dtiniciolinha: "",
          flsituacao: "",
          fltoalete: "",
          line_schedules: [],
          nomelinha: "",
          nuextensao: "",
          nulinharamal: "",
          nupontodestino: "",
          nupontoorigem: "",
          nuservicoveiculo: "",
          nutransportadora: "",
          relatable_name: "",
          relatable_render: "",
          tpatividade: "",
          patamarizada: "",
          tpoperacao: "",
          tpoutorga: "",
          tpservcompl: "",
          tpviagem: "",
          vlcoeficientemultiplicacao: "",
          markers: [],
          sectionPoints: [],
        },

        currentItinerary: "", // Armazena o itinerário sendo digitado
        itineraries: [], // Lista de itinerários já inseridos

        newRamalLine: {
          nulinharamal: "Linha",
        },

        originalLineInfo: null,

        lineFormSuccess: 0,

        sections: [],
      }
    },
    mounted() {
      this.originalLineInfo = JSON.parse(JSON.stringify(this.lineModel))
      this.$refs.createNewLineModal.show()
    },
    methods: {
      async submitLineForm() {
        try {
          let resp = null

          if (this.lineModel.idlinha) {
            resp = await this.regularLineService.updateRegularLine(
              this.lineModel.idlinha,
              this.lineModel
            )
          } else if (this.lineModel.nulinharamal === "----") {
            resp = await this.regularLineService.createRegularLine(
              this.lineModel
            )
          } else if (this.lineModel.nuextensao === "--") {
            resp = await this.regularLineService.createRamal(this.lineModel)
          }

          if (resp != null) {
            this.lineModel.idlinha = resp.line
            this.lineModel.nulinharamal = resp.nulinharamal
            this.lineModel.nuextensao = resp.nuextensao
            this.$toast.success({
              title: "Sucesso",
              message: "Linha cadastrada com sucesso",
            })
            this.originalLineInfo = JSON.parse(JSON.stringify(this.lineModel))
            this.lineFormSuccess += 1
          } else {
            this.$toast.error({
              title: "Erro",
              message: "Erro ao cadastrar linha",
            })
          }
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: error.message,
          })
        }
      },
      newLine() {
        this.lineModel.nulinharamal = "----"
        this.lineModel.nuextensao = "00"
      },
      newRamal(line) {
        this.lineModel.nulinharamal = line.nulinharamal
        this.lineModel.nutransportadora = line.nutransportadora
        this.lineModel.transportadoraForm = {
          id: line.nutransportadora,
          name: line.deter_registry.organization.business_name,
        }
        this.lineModel.nuextensao = "--"
        this.$refs.selectLineModal.hide()
      },
      discardChanges(keys) {
        keys.forEach((key) => {
          this.lineModel[key] = this.originalLineInfo[key]
        })
      },
      closeCreateNewLineModal() {
        this.$refs.createNewLineModal.hide()
        this.$router.push({ name: "lines.regular.index" })
      },
      closeSelectLineModal() {
        this.$refs.selectLineModal.hide()
        this.$router.push({ name: "lines.regular.index" })
      },
    },
  }
</script>

<style>
  .new-regular-line:hover path {
    fill: #ffffff;
  }
  .close-modal-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
</style>

<template>
  <div class="w-full bg-gray-light">
    <portal-target name="createLineModals" :multiple="true"/>
    <Modal ref="createNewLineModal" :close-on-click-outside="false">
      <div class="flex flex-col justify-around items-center p-3 h-96">
        <!-- Botão de fechar -->
        <button
          class="close-modal-btn"
          type="button"
          @click="closeCreateNewLineModal"
        >
          <Icon icon="close" class="h-6"/>
        </button>
        <h1 class="text-center">Selecione uma das opções abaixo:</h1>
        <div class="w-full h-48 grid grid-cols-2 gap-4">
          <button
            class="new-regular-line form-new-green h-full rounded-md"
            type="button"
            @click="
                            () => {
                                newLine();
                                $refs.createNewLineModal.hide();
                            }
                        "
          >
            <div class="flex flex-col items-center">
              <p class="text-lg">Nova linha</p>
              <Icon icon="newLine" class="mt-3"/>
            </div>
          </button>
          <button
            class="new-regular-line form-new-green h-full rounded-md"
            type="button"
            @click="
                            () => {
                                $refs.createNewLineModal.hide();
                                $refs.selectLineModal.show();
                            }
                        "
          >
            <div class="flex flex-col items-center">
              <p class="text-lg">Novo ramal</p>
              <Icon icon="newRamal" class="mt-3"/>
            </div>
          </button>
        </div>
      </div>
    </Modal>

    <Modal ref="selectLineModal" :close-on-click-outside="false">
      <div class="h-96 p-3">
        <!-- Botão de fechar -->
        <button
          class="close-modal-btn"
          type="button"
          @click="closeSelectLineModal"
        >
          <Icon icon="close" class="h-6"/>
        </button>
        <button
          class="absolute top-4 left-3"
          type="button"
          @click="
                        () => {
                            $refs.selectLineModal.hide();
                            $refs.createNewLineModal.show();
                        }
                    "
        >
          <Icon icon="arrowLeft" class="h-6"/>
        </button>
        <div class="flex flex-col justify-center items-center p-6">
          <h1 class="text-center mb-1">
            Selecione a linha para a qual deseja adicionar um novo ramal.
          </h1>
          <p class="text-center text-xs mb-1">
            Ao selecionar a linha, o número do ramal será gerado automaticamente
            após o preenchimento do formulário.
          </p>
          <div class="w-full">
            <SearchSelect
              :selected.sync="newRamalLine"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/lines/route/filter/unique/"
              :digits-before-search="1"
              option-key="linha"
              optional-placeholder-icon="icon_final_point.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="nulinharamal"
              type="número"
              :option-value="(linha) => linha.nulinharamal"
              @changed="newRamal"
            ></SearchSelect>
          </div>
        </div>
      </div>
    </Modal>

    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5 mb-2">
          Descrição da Linha Regular
        </h1>
      </div>
    </div>

    <div class="mb-6">
      <div class="px-2">
        <div class="px-4">
          <div class="px-4 bg-white shadow-md pt-3 pb-5 text-sm">
            <RegularLineForm
              :line-model="lineModel"
              :sections="sections"
              :line-form-success="lineFormSuccess"
              @submitLineForm="submitLineForm"
              @discardChanges="discardChanges"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
